import React from "react";
import MaterialTable from "@material-table/core";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Button } from "antd";

import moment from "moment";
import axios from "axios";
import { FILES_URL } from "../../../config/config";

import "./OpenDocumentList.css";
export function OpenDocumentList({ data, title, onUpload, isUploading }) {
  const showUploadedBy = data?.some((document) => document.uploadedByContactName);
  const columns = [
    {
      title: "Document Name",
      field: "documentName",
    },
    {
      title: "DocumentType",
      field: "documentType",
    },
    {
      title: "Upload Date",
      field: "uploadedDate",
      render: (rowData) => (
        <span>{moment(rowData?.uploadedDate).format("MM/DD/YYYY")}</span>
      ),
    },
  ].concat(
    showUploadedBy
      ? [
          {
            title: "Uploaded By",
            field: "uploadedByContactName",
          },
        ]
      : []
  );

  const onDownloadAction = (data) => {
    axios({
      url: `${FILES_URL}/${data.documentPath}`,
      method: "GET",
      responseType: "blob",
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${data.documentName}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  };

  const onViewAction = (data) => {
    const url = `${FILES_URL}/${data.documentPath}`;
    window.open(url, "_blank");
  };
  return (
    <div className="listContainer">
      {onUpload && (
        <div className="documents-list-header">
          <h3>{title}</h3>
          <Button
            type="primary"
            onClick={onUpload}
            loading={isUploading}
            icon={<FileUploadOutlinedIcon className="documents-list-header__icon" />}
          >
            Upload Document
          </Button>
        </div>
      )}
      <MaterialTable
        columns={columns}
        className="tableDocuments"
        data={data}
        title={onUpload ? "" : title}
        actions={[
          {
            icon: () => (
              <FileDownloadOutlinedIcon className="table-action-icon table-action-icon--documents" />
            ),
            tooltip: "Download",
            onClick: (event, rowData) => onDownloadAction(rowData),
          },
          {
            icon: () => (
              <VisibilityOutlinedIcon className="table-action-icon table-action-icon--view" />
            ),
            tooltip: "View",
            onClick: (event, rowData) => onViewAction(rowData),
          },
        ]}
        options={{
          actionsColumnIndex: -1,
          pageSize: 5,
          toolbar: !onUpload,
          search: false,
        }}
      />
    </div>
  );
}
